import { useState } from 'react';
import Button from '@mui/material/Button';
import InfoIcon from '@mui/icons-material/Info';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { Link } from 'react-router-dom';

export default function Label(props) {
  const { open: controlledOpen, onClose, showButton = true } = props || {};
  const [internalOpen, setInternalOpen] = useState(false);
  const isControlled = controlledOpen !== undefined;
  const open = isControlled ? controlledOpen : internalOpen;

  const handleOpen = () => {
    if (!isControlled) setInternalOpen(true);
  };
  const handleClose = () => {
    if (isControlled) {
      onClose && onClose();
    } else {
      setInternalOpen(false);
    }
  };

  return (
    <>
      {showButton && (
        <Button onClick={handleOpen}>
          <InfoIcon fontSize="large" />
        </Button>
      )}
      <Dialog open={open || false} onClose={handleClose} disableScrollLock>
        <DialogTitle>LABELING</DialogTitle>
        <DialogContent>
          <Link to="/about" target="_blank" rel="noopener">
            <img
              src="shared-assets/regulatory/Labeling.png"
              alt="Labeling"
              width="100%"
            />
          </Link>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>CLOSE</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
